import {useEffect, useRef} from 'react'
import * as d3 from 'd3'
import styled from '@emotion/styled'
import {useTheme} from '@mui/material/styles'

const LegendContainer = styled.div(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  columnGap: '6px',
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.hpBlack,
  backgroundColor: theme.palette.hpWhite,
  padding: theme.spacing(0.5)
}))

const LegendLabelHigh = styled.div(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  lineHeight: theme.typography.h6.lineHeight
}))

const LegendLabelLow = styled.div(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  lineHeight: theme.typography.h6.lineHeight
}))
const StyledSVG = styled.svg(({theme}) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '350px'
  },
  height: '14px',
  border: `1px solid ${theme.palette.hpBaseDark}`
}))

const ColorLegend = () => {
  const theme = useTheme()
  const colors = [
    theme.palette.hpAccentLightYellow,
    theme.palette.hpAccentYellowGreen,
    theme.palette.hpAccentAqua,
    theme.palette.hpAccentAquaGreen,
    theme.palette.hpAccentPersianGreen,
    theme.palette.hpPrimaryDark,
    theme.palette.hpPrimaryDarkest
  ]
  const svgRef = useRef(null)
  useEffect(() => {
    // Get the SVG container element using the useRef hook.
    const svgContainer = d3.select(svgRef.current)

    // Create the gradient element.
    const gradient = svgContainer
      .append('defs')
      .append('linearGradient')
      .attr('id', 'legend-gradient')
      .attr('x1', '0%')
      .attr('y1', '0%')
      .attr('x2', '100%')
      .attr('y2', '0%')

    for (const [i, color] of colors.entries()) {
      gradient
        .append('stop')
        .attr('offset', `${(i / (colors.length - 1)) * 100}%`)
        .attr('stop-color', color)
    }

    // Draw the gradient as a rectangle.
    svgContainer
      .append('rect')
      .attr('width', '100%')
      .attr('height', '100%') // Adjust the height as needed
      .style('fill', 'url(#legend-gradient)')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LegendContainer>
      <LegendLabelLow>Low Density</LegendLabelLow>
      <StyledSVG ref={svgRef} />
      <LegendLabelHigh>High Density</LegendLabelHigh>
    </LegendContainer>
  )
}

export default ColorLegend

/**
 * List of functions and their purpose:
 *
 * - ColorLegend: Renders a color gradient legend to represent data density from low to high.
 */
